"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lozad = _interopRequireDefault(require("lozad"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _RatioBox = require("./RatioBox.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RatioBox = function RatioBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      image = _ref.image,
      ratio = _ref.ratio;
  var width = ratio.width,
      height = ratio.height;
  var lazyLoadClass = image && 'lozad';
  var ratioBoxRef = (0, _react.useRef)(null);
  var observer = (0, _lozad["default"])();
  var observe = observer.observe;
  (0, _react.useEffect)(function () {
    observe();
    var domElement = ratioBoxRef.current;
    var backgroundImage = domElement.style.backgroundImage;

    if (backgroundImage) {
      domElement.style.backgroundImage = "url(".concat(image, ")");
    }
  }, [image, observe]);
  return /*#__PURE__*/_react["default"].createElement(_RatioBox.StyledAspectRatioContainer, {
    w: width,
    h: height,
    className: className,
    image: image
  }, /*#__PURE__*/_react["default"].createElement(_RatioBox.StyledAspectRatioObject, {
    className: lazyLoadClass,
    "data-background-image": image,
    "data-toggle-class": "active",
    ref: ratioBoxRef
  }, children));
};

RatioBox.defaultProps = {
  children: undefined,
  className: undefined,
  image: undefined,
  ratio: {
    width: 1,
    height: 1
  }
};
RatioBox.propTypes = {
  /** Ratio Box item content. */
  children: _propTypes.node,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** URL to the image that will be added to the Ratio box as a background */
  image: _propTypes.string,

  /** Aspect ratio of the content box. */
  ratio: (0, _propTypes.shape)({
    width: _propTypes.number,
    height: _propTypes.number
  })
};
RatioBox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RatioBox",
  "props": {
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Ratio Box item content.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "image": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "URL to the image that will be added to the Ratio box as a background",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ratio": {
      "defaultValue": {
        "value": "{\r\n  width: 1,\r\n  height: 1,\r\n}",
        "computed": false
      },
      "description": "Aspect ratio of the content box.",
      "type": {
        "name": "shape",
        "value": {
          "width": {
            "name": "number",
            "required": false
          },
          "height": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false
    }
  }
};
var _default = RatioBox;
exports["default"] = _default;